export class CompanyBankFilter {
  CompanyId: number;

  constructor(companyId: number) {
    this.CompanyId = companyId;
  }
}
